<template>
    <div class="index list" @scroll="onScroll">
        <div class="index-mainBackground">
        </div>
        <div class="index-i">
            <div class="top">
                <div class="top-search">
                    <div class="top-search-date">
                        <div class="icon">
                            <img src="../../assets/icon/rili.png" />
                        </div>
                        <div class="date">
                            <span @click="showCalendar">{{ openLogQuery.start + ' - ' }}</span>
                            <span @click="showEndCalendar">{{ openLogQuery.end }}</span>
                        </div>

                    </div>
                    <div class="top-search-icon" @click="refresh">
                        <img src="../../assets/icon/shuaxin.png" />
                    </div>
                </div>
            </div>
            <div class="cards " v-if="openLogList.length > 0">
                <div>
                    <div class="card" v-for="(item, index) in openLogList" :key="index">
                        <div class="card-line">
                            <div class="card-line-label">开瓶串号</div>
                            <div class="card-line-content">{{ item.no }}</div>
                        </div>
                        <div class="card-line">
                            <div class="card-line-label">商品</div>
                            <div class="card-line-content">{{ item.product_name }}</div>
                        </div>
                        <!-- <div class="card-line">
                        <div class="card-line-label">开瓶串号</div>
                        <div class="card-line-content">{{ item.shop_name || "-" }}</div>
                    </div> -->
                        <div class="card-line">
                            <div class="card-line-label">开瓶地点</div>
                            <div class="card-line-content">{{ item.province }}/{{ item.city }}/{{ item.district }}
                            </div>
                        </div>
                        <div class="card-line">
                            <div class="card-line-label">开瓶时间</div>
                            <div class="card-line-content">{{ item.created }}</div>
                        </div>
                        <div class="card-line">
                            <div class="card-line-label">销售门店</div>
                            <div class="card-line-content">{{ item.shop_name || "-" }}</div>
                        </div>
                        <!-- <div class="card-line">
                        <div class="card-line-label">开瓶奖励</div>
                        <div class="card-line-content">{{ item.shop_name || "-" }}</div>
                    </div> -->
                    </div>


                </div>

                <div v-if="total == openLogList.length && openLogList.length > 0" class="card-line-empty">没有更多数据了
                </div>
            </div>
            <div class="index-empty">
                <img src="../../assets/icon/img_zanwu.png" v-if="openLogList.length == 0" />
            </div>
        </div>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker v-model="startDate" title="开始时间" type="date" :min-date="minDate"
                @confirm="startConfirm" />
        </van-popup>
        <van-popup v-model="showEnd" position="bottom">
            <van-datetime-picker v-model="endDate" title="结束时间" confirm-button-text="确认查询" type="date"
                :min-date="minDate" @confirm="endConfirm" />
        </van-popup>
        <div class="index-logo">
            <img src="../../assets/img/logo.png">
        </div>
    </div>
</template>

<script>
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import Vue from 'vue'
import { getWeekStartAndEndDates } from "@/util/util"

Vue.use(Popup);
Vue.use(DatetimePicker);
export default {
    name: 'Decap',
    data() {
        return {
            show: false,
            showEnd: false,
            startDate: new Date(getWeekStartAndEndDates('yyyy-mm-dd').start),
            endDate: new Date(getWeekStartAndEndDates('yyyy-mm-dd').end),
            openLogList: [],
            openLogQuery: {
                start: getWeekStartAndEndDates('yyyy-mm-dd').start,
                end: getWeekStartAndEndDates('yyyy-mm-dd').end
            },
            total: 0,
            page: 1,
            size: 10,
            minDate: new Date(new Date().getTime() - 60 * 60 * 24 * 365 * 1000)
        }
    },
    created() {
        this.getopenloglist()
    },
    mounted() {
        // window.addEventListener('scroll', this.onScroll);
        // console.log(window.onscroll)
        // window.onscroll = () => {
        //     const { totalNum, rows, getCallRecord } = this
        //     // 页码计算，用来判断是否能继续加载分页数据
        //     const pageNum = totalNum % rows === 0 ? totalNum / rows : parseInt(totalNum / rows) + 1
        //     // 滚动条滚动时，距离顶部的距离
        //     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        //     // 可视区的高度
        //     const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        //     // 滚动条的总高度
        //     const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        //     // 滚动条到底部的条件
        //     if (scrollTop + windowHeight === scrollHeight) {
        //         console.log('get bottom')
        //     }
        // }
    },
    methods: {
        onScroll(event) {
            const { scrollTop, clientHeight, scrollHeight } = event.target;
            // 当滚动到底部时触发加载
            if (scrollTop + clientHeight === scrollHeight) {
                console.log('触底了哈哈哈哈哈')
                if (this.total > this.page * this.size) {
                    this.page += 1
                    this.getopenloglist()
                }

            }
        },
        showCalendar() {
            this.show = !this.show
        },
        showEndCalendar() {
            this.showEnd = !this.showEnd
        },
        startConfirm(e) {
            let datetime = this.formatTimestamp(e)
            this.openLogQuery.start = datetime
            this.showCalendar()
        },
        endConfirm(e) {
            let datetime = this.formatTimestamp(e)
            this.openLogQuery.end = datetime
            this.showEndCalendar()
            this.getopenloglist()
        },
        refresh() {
            this.openLogQuery.start = getWeekStartAndEndDates('yyyy-mm-dd').start
            this.openLogQuery.end = getWeekStartAndEndDates('yyyy-mm-dd').end
            this.getopenloglist()
        },
        getopenloglist() {
            //start   2024-04-22
            //end  2024-04-23
            let that = this;
            let url = `/shop/openlog/user/?page=${that.page}&size=${that.size}`
            url = url + `&start=${this.openLogQuery.start}&end=${this.openLogQuery.end}`
            this.axios.get(url, {
                headers: {
                    'x-user-token': that.$store.getters.token,
                }
            }).then(function (res) {
                if (res.data) {
                    that.openLogList = that.openLogList.concat(res.data.records)
                    that.total = res.data.total
                }
                if (res.data.records.length == 0) that.openLogList = res.data.records
            }).catch(function (error) {
                console.log(error)
            })
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }


    }
}

</script>

<style lang="scss" scoped>
.index {
    &-mainBackground {
        width: 100vw;
        position: absolute;
        top: 0;
        height: 233px;
        background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);
        // z-index: -1;
    }
    &-i {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-left: 16px;
        margin-right: 16px;
    }

    &-empty {
        // position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        img {
            margin-top: 45%;
            width: 200px;
            height: 200px;
        }
    }

    .top {
        position: relative;
        padding: 15px 0px 0 0px;
        margin-top: 0px;
        z-index: 100;


        &-search {
            display: flex;
            align-items: center;
            gap: 16px;

            &-date {
                display: flex;
                align-items: center;
                gap: 8px;
                flex: 1;
                height: 56px;
                padding: 12px 16px;
                margin-bottom: 0;
                background: #ffffff;
                border-radius: 12px;
                font-size: 14px;
                font-weight: 400;
                color: #718096;
                box-sizing: border-box;

                .icon {
                    width: 24px;
                    height: 24px;
                }
            }

            &-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 56px;
                height: 56px;
                background-color: #ffffff;
                border-radius: 12px;

                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }

    .cards {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 16px;



        .card {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 16px;
            background: #ffffff;
            border-radius: 16px;
            font-size: 12px;
            margin-top: 15px;

            &-tabs {
                width: 100%;
                align-self: center;
            }

            &-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 16px;
                font-weight: bold;
                color: #111827;

                &__more {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;

                    image {
                        width: 12px;
                        height: 12px;
                    }
                }

                &-edit {
                    font-size: 14px;
                    font-weight: 400;
                    color: #0CAF60;
                }
            }

            &-line {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;

                &-empty {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 16px;
                    // ? 解决小黑条
                    padding-bottom: 50px;
                    // /* 兼容 iOS < 11.2 */
                    // padding-bottom: calc(env(safe-area-inset-bottom) + $card-gap);
                    /* 兼容 iOS >= 11.2 */
                    font-size: 12px;
                    color: #A0AEC0;
                }

                &.between {
                    justify-content: space-between;
                    margin-bottom: -15px;
                }

                &-icon {
                    margin-top: 3px;
                }

                &-label {
                    font-size: 14px;
                    font-weight: 400;
                    color: #A0AEC0;
                }

                &-content {
                    max-width: 200px;
                    font-size: 14px;
                    font-weight: bold;
                    color: #111827;
                }

                .content {
                    font-weight: 400;
                    color: #989898;
                }

                &-tag {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 68px;
                    height: 33px;
                    font-size: 12px;
                    font-weight: bold;
                    border-radius: 8px;

                    &.success {
                        color: #0CAF60;
                        background: #E7F7EF;
                    }

                    &.warning {
                        color: #FE964A;
                        background: #FFF0E6;
                    }

                    &.info {
                        color: #8C62FF;
                        background: #F4F0FF;
                    }

                    &.danger {
                        color: #FD6A6A;
                        background: #FFF0F0;
                    }
                }
            }
        }
    }

    &-logo {
        // position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;
        // ? 解决小黑条
        padding-bottom: 20px;
        img {
            padding-top: 20px;
            padding-bottom: 50px;
            width: 120px;
            height: 30px;
        }
    }
}

.list {
    overflow-y: scroll;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/decap/index.vue